import { createAsyncTypes } from 'utils/ActionCreator'

export const baseCsvUrl = '/members-api/search/investigation/download/csv/'
export const emailEntityBaseCsvUrl = '/members-api/search/entity_investigation/download/csv/'
export const investigationPocBaseCsvUrl =
  '/members-api/search/entity_only_investigation/download/csv/'
export const createIncidentUrl = (id) => `/members-api/irontraps/incident/${id}/escalate`

export const POC_PAGE_SIZE = 300000
export const INVESTIGATION_SHARE_CSV_PAGE_SIZE = 100_000
export const POC_PAGE_NUMBER = 1
export const MAX_ENTITY_COUNTER = 10000

export const logTypeMock = [
  'Ironscales detected a suspicious email',
  'User reported a suspicious email',
  'Email ignored due to allow list',
  'Email ignored already marked safe',
  'Email reverted to mailbox',
]

export const reportMethodMock = ['Reported by button', 'Reported by 911 mailbox']

export const actionTakenMock = [
  'Quarantined',
  'Moved to spam',
  'No action taken',
  'Banner added',
  'Inline message added',
]

export const incidentPriorityMock = ['High', 'Medium', 'Low']

export const reportedByMock = [
  'IRONSCALES Visual Scanner',
  'IRONSCALES Community',
  'AI-Powered Incident Response',
  'DDoS Detector',
  'Impersonation Protection',
  'End-User',
]

export const bannerMock = [
  'First Time Sender',
  'Business Email Compromise',
  'Sender Address Spoofing',
  'Exact Display Name Impersonation',
  'Similar Display Name Impersonation',
  'Domain Look-Alike',
  "Company's Name Appears in Display Name",
  'Known Address in Display Name',
  'Company Brand Impersonation',
]

export const PRESUMED_SAFE = 'Presumed safe'
export const FETCH_FILTERS = createAsyncTypes('THREAT_LOG_FILTERS', 'ResolutionCenter/ThreatLog')
export const FETCH_THREAT_LOG_DATA = createAsyncTypes(
  'THREAT_LOG_DATA',
  'ResolutionCenter/ThreatLog'
)
export const SET_FILTER = 'ResolutionCenter/ThreatLog/SetFilter'
export const SET_FILTERS_FROM_URL = 'ResolutionCenter/ThreatLog/SetFiltersFromUrl'
export const SET_ALL_FILTERS = 'ResolutionCenter/ThreatLog/SetAllFilter'
export const SET_LOG_DATE_FILTER = 'ResolutionCenter/ThreatLog/SetLogDateFilter'
export const SET_ARRIVAL_DATE_FILTER = 'ResolutionCenter/ThreatLog/SetArrivalDateFilter'
export const RESET_ALL_FILTERS = 'ResolutionCenter/ThreatLog/ResetAllFilters'
export const PAGINATE_CHANGE = 'ResolutionCenter/ThreatLog/PaginateChange'
export const RESET_LOG_END_DATE = 'ResolutionCenter/ThreatLog/ResetLogEndDate'
export const RESET_ARRIVAL_END_DATE = 'ResolutionCenter/ThreatLog/ResetArrivalEndDate'
export const CREATE_INCIDENT = createAsyncTypes('CREATE_INCIDENT', 'ResolutionCenter/ThreatLog')

export const SET_UNCHANGEABLE = 'ResolutionCenter/ThreatLog/SetUnchangeable'

export const FETCH_MITIGATION_DATA_ASYNC = createAsyncTypes(
  'FETCH_MITIGATION_DATA_ASYNC',
  'ResolutionCenter/ThreatLog'
)

export const FETCH_LOGS_ENTIRE_COUNT = createAsyncTypes(
  'FETCH_LOGS_ENTIRE_COUNT',
  'ResolutionCenter/ThreatLog'
)

export const SET_DEFAULT_PRESET_ASYNC = createAsyncTypes(
  'SET_DEFAULT_PRESET',
  'ResolutionCenter/ThreatLog'
)

export const FETCH_PRESETS_ASYNC = createAsyncTypes(
  'FETCH_PRESETS_ASYNC',
  'ResolutionCenter/ThreatLog'
)

export const CREATE_PRESET_ASYNC = createAsyncTypes(
  'CREATE_PRESET_ASYNC',
  'ResolutionCenter/ThreatLog'
)

export const REMOVE_PRESET_ASYNC = createAsyncTypes(
  'REMOVE_PRESET_ASYNC',
  'ResolutionCenter/ThreatLog'
)

export const UPDATE_PRESET_ASYNC = createAsyncTypes(
  'UPDATE_PRESET_ASYNC',
  'ResolutionCenter/ThreatLog'
)

export const RELEASE_FROM_MS_QUARANTINE_ASYNC = createAsyncTypes(
  'RELEASE_FROM_MS_QUARANTINE_ASYNC',
  'ResolutionCenter/ThreatLog'
)

export const RELEASE_FROM_SPAM_ASYNC = createAsyncTypes(
  'RELEASE_FROM_SPAM_ASYNC',
  'ResolutionCenter/ThreatLog'
)
export const RELEASE_FROM_INVESTIGATION_ASYNC = createAsyncTypes(
  'RELEASE_FROM_INVESTIGATION_ASYNC',
  'ResolutionCenter/ThreatLog'
)

export const SELECT_SAVED_FILTER = 'ResolutionCenter/ThreatLog/SelectSavedFilter'

export const CHECKBOX_TOGGLE = 'ResolutionCenter/ThreatLog/CHECKBOX_TOGGLE'
export const SELECT_ALL = 'ResolutionCenter/ThreatLog/SELECT_ALL'
export const UNSELECT_ALL = 'ResolutionCenter/ThreatLog/UNSELECT_ALL'
export const SELECT_ALL_RESULTS_TOGGLE = 'ResolutionCenter/ThreatLog/SELECT_ALL_RESULTS_TOGGLE'

export const ENABLED_DISABLED_DROPDOWN_OPTIONS = [
  { value: true, label: 'Enabled' },
  {
    value: false,
    label: 'Disabled',
  },
]

export const YES_NO_DROPDOWN_OPTIONS = [
  { value: true, label: 'Yes' },
  {
    value: false,
    label: 'No',
  },
]

export const INCIDENT_BEING_CREATED = 'Pending'
export const isMocked = false

export const createIncidentErrorCodes = [403, 404, 409]
export const allowListErrorMessage =
  'Could not escalate - Email is in allow list due to admin settings policy'

export const freeTextFields = [
  'subject',
  'sender',
  'recipient',
  'incident',
  'current_incident_id',
  'links_list',
  'email_attachments_list',
]

export const FILTER_MANAGEMENT_TAB = {
  editFilters: 0,
  savedFilters: 1,
}

export const FETCH_DIRECTORY_TAGS = createAsyncTypes(
  'FETCH_DIRECTORY_TAGS',
  'ResolutionCenter/ThreatLog'
)

export const SET_TAGS_PAGE = 'ResolutionCenter/ThreatLog/SET_TAGS_PAGE'
export const SET_TAGS_SEARCH = 'ResolutionCenter/ThreatLog/SET_TAGS_SEARCH'
export const investigationFilterSessionStorageKey = 'investigationFilter'

export const SET_LOADER = 'ResolutionCenter/ThreatLog/SetLoader'

export const CLOSE_ALLOW_LIST_MODAL = 'ResolutionCenter/ThreatLog/CloseAllowListModal'
export const RELEASABLE_SPAM_EMAILS_SAVED_FILTER_CONST = 'Releasable spam emails'
